import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import { dayjst } from '@/lib/dayjst';

const useClock = (): dayjs.Dayjs => {
  const [currentTime, setCurrentTime] = useState<dayjs.Dayjs>(dayjst());

  useEffect(() => {
    const intervalId = setInterval(() => setCurrentTime(dayjst()), 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return currentTime;
};

export default useClock;
